export const tenant = "au";
export const environment = "aus-production";
